import config from '../config';
import { STAGING_BUILDER_ORIGIN, STOREFRONT_ORIGIN } from '../config/tenant';

// Short-link domains must be ones only Lashbrook can create links on, since the redirect target isn't checked.
const PRODUCTION_HOSTS = [new URL(STOREFRONT_ORIGIN).hostname, 'lashbrook.link'];
const STAGING_HOSTS = [new URL(STAGING_BUILDER_ORIGIN).hostname];

// Staging only approves itself so production kiosks can never be sent to a staging QR code.
export const qrScannerAllowedHosts = () => {
  const host = window.location.hostname;
  return STAGING_HOSTS.includes(host) ? [...PRODUCTION_HOSTS, host] : PRODUCTION_HOSTS;
};

// CloudFront environment settings arrive as strings, so lists may be comma-separated.
const settingList = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.map(String);
  if (typeof value === 'string')
    return value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  return [];
};

export const qrScannerEnabled = () => config.qrScannerEnabled !== false && config.qrScannerEnabled !== 'false';

export const qrScannerParentOrigins = () => settingList(config.qrScannerParentOrigins);

export const approvedScanUrl = (text: string, allowedHosts: string[], allowedPaths: RegExp[] = []) => {
  let url: URL;
  try {
    url = new URL(text.trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  if (url.username || url.password) return null;
  if (!allowedHosts.includes(url.hostname.toLowerCase())) return null;
  if (allowedPaths.length && !allowedPaths.some((pattern) => pattern.test(url.pathname))) return null;
  return url;
};
